import { Button, ButtonProps } from "@mui/material";
import { Link } from "react-router-dom";

export default function ButtonLink(props: ButtonProps<Link>) {
    return <Button color="primary" component={Link} {...props} />;
}
